import React, { Component } from 'react'
import Standard from './Standard'

class Toggle extends Component {
  render = () => {
    return <Standard {...this.props} toggle />
  }
}

export default Toggle
